import * as _ from '@antv/util';
export { Facet } from './base';
// 所有的 Facet 类
var Facets = {};
/**
 * 根据 type 获取 facet 类
 * @param type
 */
export var getFacet = function (type) {
    return Facets[_.lowerFirst(type)];
};
/**
 * 注册一个 Facet 类
 * @param type
 * @param ctor
 */
export var registerFacet = function (type, ctor) {
    Facets[_.lowerFirst(type)] = ctor;
};
//# sourceMappingURL=index.js.map